export default __webpack_public_path__ + "static/media/dashboard-icon.5e3af5eb.svg";